import { render, staticRenderFns } from "./WeiqiPopup.vue?vue&type=template&id=f2f7448c&scoped=true"
import script from "./WeiqiPopup.vue?vue&type=script&lang=js"
export * from "./WeiqiPopup.vue?vue&type=script&lang=js"
import style0 from "./WeiqiPopup.vue?vue&type=style&index=0&id=f2f7448c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f7448c",
  null
  
)

export default component.exports